module.exports = __webpack_public_path__ + "static/media/AMInactivo.b0121366.svg";